/* eslint-disable jsx-a11y/anchor-is-valid */

import {
  Box,
  Stack,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

import TextField from '../../../forms/TextField';

export default function Tag() {
  const [ showHelp, setShowHelp ] = useState(false);

  return(
    <Stack>
      <TextField
        name="tag"
        label='Complete HTML'
        multiline
        rows={5}
        inputProps={{ readOnly: true }}
      />
      <Typography variant='caption'>
        <a href="#" onClick={(e) => { e.stopPropagation(); e.preventDefault(); setShowHelp(!showHelp)}}>
          { showHelp ? 'Hide' : 'Show' } Help
        </a>
      </Typography>
      { showHelp && (<Box>
        <p>
          <Typography variant='caption'>
            Regular campaign urls that we can redirect to should use url macros: %&#123;URL0&#125;, %&#123;URL1&#125;, etc.
            To use HTML encoded versions use %&#123;eURL0&#125;, %&#123;eURL1&#125;.
            <em
              >This can be used in the href portion of the a tag. &lt;a
              href=&quot;%&#123;URL0&#125;&quot;&gt;click me&lt;/a&gt;</em
            >
          </Typography>
        </p>
        <p>
          <Typography variant='caption'>
            For click tracking through a pixel (image) use: %&#123;pURL0&#125;, %&#123;pURL1&#125;, etc. To use url-encoded
            versions use %&#123;epURL0&#125;, %&#123;epURL1&#125;.
            <em
              >This can be used in special situations where a 3rd party will handle redirecting the user
              and needs to load an image for click tracking.</em
            >
          </Typography>
        </p>
        <p>
          <Typography variant='caption'>
            For thid party click redirects use: %&#123;tURL0&#125;, %&#123;tURL1&#125;, etc. To use url-encoded versions
            %&#123;etURL0&#125;, %&#123;etURL1&#125;.
            <em>This can be used for javascript dynamic redirects where the click url is substituted in
              after our macro. ex: var click = %&#123;tURL0&#125;[THIRD_PARTY_MACRO]
            </em>
          </Typography>
        </p>
      </Box>
      )}
    </Stack>
  )
}
